import { HexColorPicker } from "react-colorful";
import "./ColorPickerModal.scss";
import { useRef } from "react";

function ColorModal({ isOpen, color, onClose, setColor }) {
  const tempColorRef = useRef(color);

  if (!isOpen) return null;

  function handleValidate() {
    setColor(tempColorRef.current);
    onClose();
  }

  return (
    <div className="color-picker-modal">
      <div className="color-picker-modal-content">
        <h2>Choisir une couleur</h2>
        <HexColorPicker
          color={tempColorRef.current}
          onChange={(newColor) => {
            tempColorRef.current = newColor;
          }}
        />

        <div className="color-picker-modal-content-buttons">
          <button onClick={onClose}>Annuler</button>
          <button onClick={handleValidate}>Valider</button>
        </div>
      </div>
    </div>
  );
}

export default ColorModal;
